import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TaxisService } from './order.service';
import { firstValueFrom } from 'rxjs';

export interface RetailerLocation {
  _id: string;
  onlineTitle: string;
  displayTitle: string;
  lat: number;
  lng: number;
  retailerId: string;
}

@Injectable({
  providedIn: 'root'
})
export class ProximityService {
  constructor(private http: HttpClient, private taxisService: TaxisService) {}

  getProximityFromIP(): Promise<{
    lat: number;
    lng: number;
  }> {
    return this.http.get<any>('https://ipinfo.io/json')
      .toPromise()
      .then(response => {
        if (!response.loc) {
          throw new Error('Location data not found');
        }

        const [lat, lng] = response.loc.split(',').map(Number);

        return {
          lat,
          lng,
        };
      })
      .catch(() => {
        throw new Error('Failed to get proximity from IP');
      });
  }

  findNearestRetailer(
    userLat: number,
    userLng: number,
    retailers: RetailerLocation[]
  ): RetailerLocation & { distanceKm: number } {
    let nearest: RetailerLocation | null = null;
    let minDistance = Infinity;

    for (const retailer of retailers) {
      const distance = this.getDistanceInKm(
        userLat,
        userLng,
        retailer.lat,
        retailer.lng
      );

      if (distance < minDistance) {
        minDistance = distance;
        nearest = retailer;
      }
    }

    return {
      ...nearest!,
      distanceKm: Number(minDistance.toFixed(2)),
    };
  }

  async getRetailerFromIP(
    retailers: RetailerLocation[]
  ): Promise<RetailerLocation & { distanceKm: number }> {
    const proximity = await this.getProximityFromIP();
    return this.findNearestRetailer(proximity.lat, proximity.lng, retailers);
  }

  private toRad(value: number): number {
    return (value * Math.PI) / 180;
  }

  private getDistanceInKm(
    lat1: number,
    lng1: number,
    lat2: number,
    lng2: number
  ): number {
    const R = 6371; // Rayon de la Terre en km

    const dLat = this.toRad(lat2 - lat1);
    const dLng = this.toRad(lng2 - lng1);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.toRad(lat1)) *
        Math.cos(this.toRad(lat2)) *
        Math.sin(dLng / 2) *
        Math.sin(dLng / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c;
  }


  lastSearchAddressNotFound:string='';
  async getPredictions(address: string,autocompleteSrv:google.maps.places.AutocompleteService,retailerId:string): Promise<any> {

    if(!this.lastSearchAddressNotFound || !address.includes(this.lastSearchAddressNotFound) && this.lastSearchAddressNotFound!=address){
    let predictions = await firstValueFrom(this.taxisService.searchPredictions(address,retailerId));
    let prediction = this.mapToPrediction(predictions);
    console.log('PREDICTIONS FROM BACKEND ==> ', prediction);
    if(prediction.length>0){
        this.lastSearchAddressNotFound='';
        return prediction;
    }
    }
    this.lastSearchAddressNotFound = address;

    
    let locations = await new Promise((resolve, reject) => {
        autocompleteSrv.getPlacePredictions(
        {
            input: address,
            componentRestrictions: { country: 'ma' },
        },
        (predictions:any, status:any) => {
            if (status == google.maps.places.PlacesServiceStatus.OK) {
            resolve(predictions);
            // Mark for check
            // this._changeDetectorRef.markForCheck();
            } else {
            resolve([]);
            // Mark for check
            // this._changeDetectorRef.markForCheck();
            }
        }
        );
    });

    console.log('AUTOCOMPLETE LOCATIONS FROM GOOGLE MAPS ==> ', locations);
    return locations;  
  }

  private mapToPrediction(prediction: any[]): any[]{
    return prediction.map((item: any) => ({
      description: item.title,
      place_id: item.place_id,
      lat:item.latitude,
      lng:item.longitude,
    //   structuredFormatting: item.structured_formatting,
    }));
  }





}
